import { render, staticRenderFns } from "./r-item-touch-config.vue?vue&type=template&id=15d9fb7e"
import script from "./r-item-touch-config.vue?vue&type=script&lang=js"
export * from "./r-item-touch-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15d9fb7e')) {
      api.createRecord('15d9fb7e', component.options)
    } else {
      api.reload('15d9fb7e', component.options)
    }
    module.hot.accept("./r-item-touch-config.vue?vue&type=template&id=15d9fb7e", function () {
      api.rerender('15d9fb7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/touch/r-item-touch-config.vue"
export default component.exports